/*
File: 包含时间选择的账单组件
Author: SimonLu<luzuoqing@huya.com>
Date: 2020-03-17
*/

import React, { useEffect, useCallback, useState } from 'react'
import { useAction } from '@/hooks/useAction'
import { Button, DatePicker, Table  } from 'antd'
import { format, startOfMonth, endOfMonth } from 'date-fns/fp'
import * as R from 'ramda'

// TODO 换掉antd 的时间选择器, 以摆脱 moment
import moment from 'moment'
import 'moment/locale/zh-cn';

import styles from './style.scss?__local'
const { RangePicker } = DatePicker
moment.locale('zh-cn');

const mockData = {
  page: 1,
  pageSize: 20,
  total: 80,
  data: [
    {
      statementDate: '20200301',
      lPid: '202003029ajv0w8z',
      extUuid: '商品aa',
      goodsUuid: '商品BBB',
      payExpense: 'gift',
      expenseLevel: 29,
      expenseDate: 3,
      payOrderId: null,
      goodsExpenseDetail: 1583846256,
      recordingFlowId: 1583846256,
      recordingStatus: 1583846256,
      recordingDate: 1583846256,
      description: 1583846256,
      createTime: 1583846256,
      updateTime: 1583846256,
    },
    {
      statementDate: '20200301',
      lPid: '202003029ajv0w8z',
      extUuid: '商品aa',
      goodsUuid: '商品BBB',
      payExpense: 'gift',
      expenseLevel: 29,
      expenseDate: 3,
      payOrderId: null,
      goodsExpenseDetail: 1583846256,
      recordingFlowId: 1583846256,
      recordingStatus: 1583846256,
      recordingDate: 1583846256,
      description: 1583846256,
      createTime: 1583846256,
      updateTime: 1583846256,
    },
    {
      statementDate: '20200302',
      lPid: '202003029ajv0w8z',
      extUuid: '商品aa',
      goodsUuid: '商品BBB',
      payExpense: 'gift',
      expenseLevel: 29,
      expenseDate: 3,
      payOrderId: null,
      goodsExpenseDetail: 1583846256,
      recordingFlowId: 1583846256,
      recordingStatus: 1583846256,
      recordingDate: 1583846256,
      description: 1583846256,
      createTime: 1583846256,
      updateTime: 1583846256,
    },
  ],
}

const mockDataUnpay = {
  types: [{type: 1, name: '主播使用时长', unit: '分钟', maxServiceFee: 120}, {type: 2, name: '使用小程序流水', unit: '金豆', maxServiceFee: 120}],
  serviceBacks: [
    {
      orderId: '19092114424499999991',
      extInfo: {
        name: '测试创建扩展2',
        extUuid: '31233',
      },
      time: '2019-08',
      fee: 200,
      condition: {
        type: 0,
        condition: 100,
      },
    },
    {
      orderId: '190921144244923191',
      extInfo: {
        name: '测试创建扩展',
        extUuid: '7zp9wg9s',
      },
      time: '2019-08',
      fee: 200,
      condition: {
        type: 0,
        condition: 100,
      },
    },
  ],
  sum: 2000,
}

const formatMomentToDatefns = R.pipe(
  R.replace('YYYY', 'yyyy'),
  R.replace('DD', 'dd'),
)

function BillWithDate({
  initStartTime,
  initEndTime,
  fetcher,
  columns,
  transformer = R.prop('data'),
  reFetchCnt = 0,
  dateFormat = 'YYYY-MM',
}) {
  const [{ isLoading, respData, error }, performAction] = useAction(fetcher)

  const [dates, setDates] = useState(() => [moment(initStartTime), moment(initEndTime)])

  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  })

  const query = () => performAction({
    page: pagination.page,
    pageSize: pagination.pageSize,
    beginTime: R.compose(
      format(formatMomentToDatefns(dateFormat)),
      startOfMonth,
    )(dates[0].valueOf()),
    endTime: R.compose(
      format(formatMomentToDatefns(dateFormat)),
      endOfMonth,
    )(dates[1].valueOf()),
  })

  useEffect(() => {
    query()
  }, [pagination])

  useEffect(() => {
    if (reFetchCnt > 0) {
      query()
    }
  }, [reFetchCnt])


  const handleDateChange = useCallback(datesValue => {
    setDates(datesValue)
  }, [])

  const handlePageChange = useCallback(page => {
    setPagination(R.mergeLeft({ page }))
  }, [])

  // dataSource={transformer(R.prop('data', respData))}
  // dataSource={transformer(R.prop('serviceBacks', mockDataUnpay))}
  return (
    <div className={styles.data_wrapper}>
      <div className={styles.header}>
        <RangePicker
          placeholder={['开始月份', '结束月份']}
          format={dateFormat}
          onChange={handleDateChange}
          onPanelChange={handleDateChange}
          mode={['month', 'month']}
          value={dates}
        />

        <Button onClick={query} className={styles.search_btn} type="primary">查看</Button>
      </div>

      <div style={{ backgroundColor: 'white', borderRadius: '4px', paddingTop: '0' }}>
        <Table
          columns={columns}
          dataSource={transformer(respData)}
          pagination={{
            current: pagination.page,
            pageSize: pagination.pageSize,
            // total: mockData.total,
            total: R.prop('total', respData),
            onChange: handlePageChange,
          }}
          loading={isLoading}
        >
        </Table>
      </div>
    </div>
  )
}

export default BillWithDate
